import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import PageLogin from '@/pages/PageLogin'

import DefaultContainer from '@/container/DefaultContainer'
import LargeContainer from '@/container/LargeContainer'
import ProjectContainer from '@/container/ProjectContainer'

import AjoutClientEditeur from '@/components/ajoutClientEditeur'
import ListingClientEditeur from '@/components/listingClientEditeur'
import ListingClients from '@/components/listingClients'
import AjoutUserByEditeur from '@/components/ajoutUserByEditeur'
import ListingUserByEditeur from '@/components/listingUserByEditeur'

import pageAllProjects from '@/pages/pageAllProjects'

import pageTableau from '@/pages/pageTableau'
import readOnlyTableau from '@/pages/pageTableau/readOnlyTableau'

import dashboard from '../components/dashboardComponent'
import Statistiques from '../components/statistiques'
import { allRole } from '../config/constanteUse'

// page
import pageInscription from '@/pages/PageConfirmationCompte'
import pageRecuperation from '@/pages/PageRecuperationPassword'

import pageFicheEspace from '@/pages/pageFicheEspace'
import pageInviteFicheEspace from '@/pages/pageFicheEspace/pageInviteFicheEspace'
import pageEditFicheEspace from '@/pages/pageEditFicheEspace'
import pageTemplateFiche from '@/pages/pageTemplateFiche'
import pageSchemaFonctionnel from '@/pages/pageSchemaFonctionnel'
// import pageReadOnlySchema from '@/pages/pageSchemaFonctionnel/readOnlySf'
// import pageCahiersEnvironnemental from '@/pages/pageCahiersEnvironnemental'

Vue.use(Router)

const routes = [
  { path: '/', redirect: 'login' },
  {
    path: '/mes-clients',
    component: DefaultContainer,
    children: [
      {
        path: '/',
        component: ListingClients,
        meta: {
          requiresAuth: true,
          permission: allRole
        }
      }
    ]
  },
  {
    path: '/mes-tableaux/:idProject',
    component: ProjectContainer,
    props: { active: true },
    children: [
      {
        path: '/',
        name: 'tableau_surface',
        component: pageTableau, // pageTableauDeSurface
        meta: {
          requiresAuth: true,
          permission: allRole
        }
      }
    ]
  },
  {
    path: '/fiches-espaces/:idProject/edit/:idFiche',
    component: ProjectContainer,
    props: { fdeActive: true },
    children: [
      {
        path: '/',
        name: 'edit_fiche_espace',
        component: pageEditFicheEspace, // pageFicheEspace
        meta: {
          requiresAuth: true,
          permission: allRole
        }
      }
    ]
  },
  {
    path: '/fiches-espaces/:idProject',
    component: ProjectContainer,
    props: { fdeActive: true },
    children: [
      {
        path: '/',
        name: 'fiche_espace',
        component: pageFicheEspace, // pageFicheEspace
        meta: {
          requiresAuth: true,
          permission: allRole
        }
      }
    ]
  },
  {
    path: '/templates-fiches/:idProject',
    component: ProjectContainer,
    props: { fdeActive: true },
    children: [
      {
        path: '/',
        name: 'template_fiche_espace',
        component: pageTemplateFiche, // pageFicheEspace
        meta: {
          requiresAuth: true,
          permission: allRole
        }
      }
    ]
  },
  {
    path: '/schemas-fonctionnels/:idProject',
    component: ProjectContainer,
    props: { schActive: true },
    children: [
      {
        path: '/',
        name: 'schema_fonctionnel',
        component: pageSchemaFonctionnel,
        meta: {
          requiresAuth: true,
          permission: allRole
        }
      }
    ]
  },
  {
    path: '/mes-projets',
    component: LargeContainer,
    children: [
      {
        path: '/',
        component: pageAllProjects,
        meta: {
          requiresAuth: true,
          permission: allRole
        }
      }
    ]
  },
  {
    path: '/dashboard',
    component: DefaultContainer,
    meta: {
      requiresAuth: true,
      permission: ['ROLE_EDITEUR']
    },
    children: [
      {
        path: '/',
        name: 'DefaultContainer',
        components: {
          default: '',
          admin: dashboard
        },
        meta: {
          requiresAuth: true,
          permission: allRole
        }
      },
      {
        path: 'liste-clients',
        component: ListingClientEditeur,
        props: {
          titre: 'Création de compte',
          wrapclass: 'col-md-4'
        },
        meta: {
          requiresAuth: true,
          permission: ['ROLE_EDITEUR']
        }
      },
      {
        path: 'create-client',
        component: AjoutClientEditeur,
        meta: {
          requiresAuth: true,
          permission: ['ROLE_EDITEUR']
        }
      },
      {
        path: 'edit-client/:id',
        component: AjoutClientEditeur,
        meta: {
          requiresAuth: true,
          permission: ['ROLE_EDITEUR']
        }
      },
      {
        path: 'create-user/:idclient',
        component: AjoutUserByEditeur,
        meta: {
          requiresAuth: true,
          permission: ['ROLE_EDITEUR']
        }
      },
      {
        path: 'edit-user/:idclient/:iduser',
        component: AjoutUserByEditeur,
        meta: {
          requiresAuth: true,
          permission: ['ROLE_EDITEUR']
        }
      },
      {
        path: 'list-user/:id',
        name: 'List user',
        component: ListingUserByEditeur,
        meta: {
          requiresAuth: true,
          permission: ['ROLE_EDITEUR']
        }
      },
      {
        path: 'statistiques',
        name: 'Statistiques connexion',
        component: Statistiques,
        meta: {
          requiresAuth: true,
          permission: ['ROLE_EDITEUR']
        }
      }
    ]
  },
  {
    path: '/confirmation/:token',
    component: pageInscription
  },
  {
    path: '/recuperation-mot-de-passe/:token',
    component: pageRecuperation
  },
  { path: '/login', name: 'Login', component: PageLogin },
  // {
  //   path: '/cahiers-environnemental/:idProject',
  //   component: ProjectContainer,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'cahier_environnemental',
  //       component: pageCahiersEnvironnemental, // pageCahiersEnvironnemental
  //       meta: {
  //         requiresAuth: true,
  //         permission: allRole
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/invite/cahiers-environnementals/:idProject/:idInvitation/:tokenInvite',
  //   component: ProjectContainer,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'cahier_environnemental invite',
  //       component: pageCahiersEnvironnemental, // pageCahiersEnvironnemental
  //       meta: {
  //         requiresAuth: false
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/specifications-techniques/:idProject',
  //   component: ProjectContainer,
  //   children: [
  //     {
  //       name: 'specification_technique',
  //       path: '/',
  //       component: pageCahiersEnvironnemental, // specifications-techniques
  //       meta: {
  //         requiresAuth: true,
  //         permission: allRole,
  //         type: 'spec'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/invite/specifications-techniques/:idProject/:idInvitation/:tokenInvite',
  //   component: ProjectContainer,
  //   children: [
  //     {
  //       name: 'specification_technique invite',
  //       path: '/',
  //       component: pageCahiersEnvironnemental, // specifications-techniques
  //       meta: {
  //         requiresAuth: false,
  //         type: 'spec'
  //       }
  //     }
  //   ]
  // },

  // Updated invite links
  {
    path: '/invite/mes-tableaux/:idProject/:idInvitation/:tokenInvite',
    component: ProjectContainer,
    props: { active: true },
    children: [
      {
        path: '/',
        name: 'tableau_surface invite',
        component: readOnlyTableau, // pageTableauDeSurface
        meta: {
          requiresAuth: false
        }
      }
    ]
  },
  {
    path: '/invite/fiches-espaces/:idProject/:idInvitation/:tokenInvite',
    component: ProjectContainer,
    props: { fdeActive: true },
    children: [
      {
        path: '/',
        name: 'fiche_espace invite',
        component: pageInviteFicheEspace, // pageFicheEspace
        meta: {
          requiresAuth: false
        }
      }
    ]
  },
  {
    path: '/invite/fiches-espaces/:idProject/edit/:idFiche/:idProject/:idInvitation/:tokenInvite',
    component: ProjectContainer,
    props: { fdeActive: true },
    children: [
      {
        path: '/',
        name: 'edit_fiche_espace',
        component: pageEditFicheEspace, // pageFicheEspace
        meta: {
          requiresAuth: false,
          permission: allRole
        }
      }
    ]
  },
  {
    path: '/invite/templates-fiches/:idProject/:idProject/:idInvitation/:tokenInvite',
    component: ProjectContainer,
    props: { fdeActive: true },
    children: [
      {
        path: '/',
        name: 'template_fiche_espace',
        component: pageTemplateFiche, // pageFicheEspace
        meta: {
          requiresAuth: false,
          permission: allRole
        }
      }
    ]
  },
  {
    path: '/invite/schemas-fonctionnels/:idProject/:idInvitation/:tokenInvite',
    component: ProjectContainer,
    props: { schActive: true },
    children: [
      {
        path: '/',
        name: 'schema_fonctionnel invite',
        component: pageSchemaFonctionnel, // pageReadOnlySchema
        meta: {
          requiresAuth: false
        }
      }
    ]
  }
  // {
  //   path: '/invite/mes-tableaux/:idProject/:tokenInvite',
  //   component: ProjectContainer,
  //   props: { active: true },
  //   children: [
  //     {
  //       path: '/',
  //       name: 'tableau_surface invite',
  //       component: readOnlyTableau, // pageTableauDeSurface
  //       meta: {
  //         requiresAuth: false
  //       }
  //     }
  //   ]
  // }
]

const router = new Router({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (store.getters.expireDate !== 0 && store.getters.expireDate < Date.now() / 1000) {
        next('/login')
        return
      }

      if (to.meta.permission.includes(store.getters.userRole)) {
        next()
        return
      }
    }
    next('/login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js